import React from 'react';
import PropTypes from 'prop-types';
import trans from 'translate';
import BackIcon from '../Common/Icons/BackIcon';

import CloseIcon from '../Common/Icons/CloseIcon';
import './modals.scss';

const ModalBody = ({ children, onBack, title, closeModal }) => (
  <div className="modal-body">
    <div className="modal-header">
      <div className="modal-title-wrapper">
        {onBack && <BackIcon onClick={() => onBack?.()} className="clickable" />}
        <div className="modal-title">{trans(title)}</div>
      </div>
      <span onClick={closeModal} className="icon-close">
        <CloseIcon size={21} />
      </span>
    </div>
    <div className="modal-body-content">{children}</div>
  </div>
);

ModalBody.defaultProps = {
  onBack: null,
};

ModalBody.propTypes = {
  children: PropTypes.node.isRequired,
  closeModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  onBack: PropTypes.any,
};

export default ModalBody;
